import {
    ACC_USER_AVATAR_VIEW,
    ACC_USER_AVATAR_VIEW_FAIL,
    ACC_USER_AVATAR_VIEW_RESET,
    ACC_USER_AVATAR_VIEW_SUCCESS,
    ACC_USER_AVATAR_VIEW_CLEAR_CACHE
} from './constants';

// 头像
export const accountUserAvatarViewReset = () => ({
    type: ACC_USER_AVATAR_VIEW_RESET,
    payload: null,
});
export const accountUserAvatarViewClearCache = () => ({
    type: ACC_USER_AVATAR_VIEW_CLEAR_CACHE,
    payload: null,
});
export const accountUserAvatarView = ({userId, blobUrls}) => ({
    type: ACC_USER_AVATAR_VIEW,
    payload: {userId, blobUrls},
});
export const accountUserAvatarViewSuccess = (data) => ({
    type: ACC_USER_AVATAR_VIEW_SUCCESS,
    payload: data,
});
export const accountUserAvatarViewFail = (data) => ({
    type: ACC_USER_AVATAR_VIEW_FAIL,
    payload: data,
});